<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="dark" fixed="bottom">
      <b-navbar-nav>
        
          <b-nav-text>
            <div class="fb-page" data-href="https://www.facebook.com/silkradio" data-tabs="" data-width="" data-height="" data-small-header="true" data-adapt-container-width="false" data-hide-cover="true" data-show-facepile="false"><blockquote cite="https://www.facebook.com/silkradio" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/silkradio">Silk Radio</a></blockquote></div>
          </b-nav-text>
      </b-navbar-nav>      
      <b-navbar-nav class="ml-auto d-none d-sm-block">
        <b-navbar-brand href="https://www.facebook.com/silkradio">Silk radio - {{ year }}</b-navbar-brand>
        <b-nav-text>Artwork by <a href="https://www.signalnoise.com/">signalnoise</a></b-nav-text>
      </b-navbar-nav>
    </b-navbar>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  computed: {
    year() {
      let today = new Date()
      return today.getFullYear()
    }
  }
}
</script>

<style>
  body,
  html, #app {
    height: 100%;
    color: white;
  }
</style>
